"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const PendingIcon = createSVGIcon(
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5038 16.7334C12.9992 16.7334 16.6435 13.0891 16.6435 8.59368C16.6435 4.09825 12.9992 0.453979 8.5038 0.453979C4.00837 0.453979 0.364105 4.09825 0.364105 8.59368C0.364105 13.0891 4.00837 16.7334 8.5038 16.7334Z"
      fill={Core.icon.warning}
    />
    <line
      x1="5.74796"
      y1="8.09363"
      x2="11.2597"
      y2="8.09363"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </>,
  "PendingIcon",
  {
    viewBox: "0 0 17 17",
    titleAccess: "PendingIcon",
    color: "white",
  }
);
